import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          <strong>
            Designed and built with<span className="footer-heart"> ❤ </span>
          </strong>
        </p>
        <p>
          <strong>by Manu Maldonado ~ 2023</strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
